import React, { useState, useEffect, useRef } from 'react';
import { FaLandmark, FaFileInvoiceDollar, FaUserShield } from 'react-icons/fa'; // Import icons from react-icons
import './PopOutTabs.css';

const PopOutTabs = ({ initiateBotResponse }) => {
  const [activeTab, setActiveTab] = useState(null);
  const bottomRef = useRef(null);

  const handleTabClick = (tabIndex) => {
    setActiveTab((prevTab) => (prevTab === tabIndex ? null : tabIndex)); // Toggle tab visibility
  };

  const handleChatClick = () => {
    setActiveTab(null); // Close the tab content after clicking on the invitation
    initiateBotResponse(); // Trigger the bot response
  };

  // Scroll to the bottom whenever the activeTab changes or content is updated
  useEffect(() => {
    if (activeTab) {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeTab]);

  return (
    <div className="tabs-container">
      {/* Tab 1 - Government */}
      <div className="tab">
        <div className="tab-label" onClick={() => handleTabClick(1)}>
          <FaLandmark size={20} /> {/* Government icon */}
        </div>
        {activeTab === 1 && (
          <div className="tab-content">
            <h3>Government Audits<br />
            and Internal Control Testing Services</h3>
            <p>Our audit services offer the highest level of assurance, 
              specifically designed to meet the needs of government agencies and programs. 
              We provide an independent and objective evaluation to ensure the accuracy and reliability 
              of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
              meaning an absolutely high level of confidence that the financial statements are free from material misstatement.
            </p>
            <div ref={null}></div>
          </div>
        )}
      </div>

      {/* Tab 2 - Financial Audits */}
      <div className="tab">
        <div className="tab-label" onClick={() => handleTabClick(2)}>
          <FaFileInvoiceDollar size={20} /> {/* Financial audit icon */}
        </div>
        {activeTab === 2 && (
          <div className="tab-content">
            <h3>Understanding the Financial Audit Process</h3>
            <p>During the audit process, we gain a comprehensive 
              understanding of internal controls and assess compliance 
              with applicable regulations and standards. We also identify potential areas of risk, including fraud risk, 
              and ensure that all relevant disclosures and amounts in the financial statements are properly supported through audit evidence. 
              Our approach ensures transparency, accountability, and compliance with government standards.
            </p>
            <div ref={null}></div>
          </div>
        )}
      </div>

      {/* Tab 3 - Internal Controls */}
      <div className="tab">
        <div className="tab-label" onClick={() => handleTabClick(3)}>
          <FaUserShield size={20} /> {/* Internal controls icon */}
        </div>
        {activeTab === 3 && (
          <div className="tab-content">
            <h3>Ensuring Internal Controls for Government and Agencies</h3>
            <p>Our internal control evaluation ensures that government agencies comply with applicable regulations and standards. 
              We evaluate risk, fraud controls, and all necessary financial disclosures to ensure accurate and reliable reporting.
            </p>
            <div ref={null}></div>
          </div>
        )}
      </div>

      {/* Tab 4 - Chatbot Invite */}
      <div className="tab">
        <div className="tab-label" onClick={() => handleTabClick(4)}>
          Chat with Us
        </div>
        {activeTab === 4 && (
          <div className="tab-content">
            <div className="chat-invite">
              <h3>Let's Chat!</h3>
              <p>To get the full scoop on how TJG CPAs can help you, why not chat with us? 
                Our chatbot is ready to answer your questions and provide you with more insights about our services.
              </p>
              <div className="chatbot-animation">
                <span role="img" aria-label="waving hand" className="waving-hand">👋</span>
                <p className="chat-message clickable-text" onClick={handleChatClick}>
                  Tap here to chat with us!
                </p>
              </div>
            </div>
            <div ref={bottomRef}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopOutTabs;








// import React, { useState, useEffect, useRef } from 'react';
// import { FaLandmark, FaFileInvoiceDollar, FaUserShield } from 'react-icons/fa';
// import './PopOutTabs.css';

// const PopOutTabs = ({ initiateBotResponse }) => {
//   const [activeTab, setActiveTab] = useState(null);
//   const bottomRef = useRef(null); // Define the ref at the top level

//   const handleTabClick = (tabIndex) => {
//     setActiveTab((prevTab) => (prevTab === tabIndex ? null : tabIndex)); // Toggle tab visibility
//   };

//   const handleChatClick = () => {
//     setActiveTab(null); // Close the tab content after clicking on the invitation
//     initiateBotResponse(); // Trigger the bot response
//   };

// // Scroll to the bottom whenever the activeTab changes or content is updated
// useEffect(() => {
//   if (activeTab) {
//     bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }
// }, [activeTab]);

//   return (
//     <div className="tabs-container">
//       {/* Tab 1 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(1)}
//         >
//           Info 1
//         </div>
//         {activeTab === 1 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             Government Audit and Internal Control Testing Services<br /></h3>

//             Understanding Government Audits<br /><br />

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning an absolutely high level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 2 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(2)}
//         >
//           Info 2
//         </div>
//         {activeTab === 2 && (
//           <div className="tab-content">
//             <h3>Understanding the Audit Process..<br />
//             Government Audit and Internal Control Testing<br /></h3>

//             <p>During the audit process, we gain a comprehensive 
//               understanding of internal controls and assess compliance 
//               with applicable regulations and standards. We also identify potential areas of risk, including fraud risk, 
//               and ensure that all relevant disclosures and amounts in the financial statements are properly supported through audit evidence. 
//               Our approach ensures transparency, accountability, and compliance with government standards.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 3 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(3)}
//         >
//           Info 3
//         </div>
//         {activeTab === 3 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             Government Audit and Internal Control Testing Services<br /></h3>

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning a high but not absolute level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 4 - Chatbot Invite */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(4)}  // Show the tab content on click
//         >
//           Chat with Us
//         </div>
//         {activeTab === 4 && (
//           <div className="tab-content">
//             <div className="chat-invite">
//               <h3>Let's Chat!</h3>
//               <p>
//                 To get the full scoop on how TJG CPAs can help you, why not chat with us? 
//                 Our chatbot is ready to answer your questions and provide you with more insights about our services.
//               </p>
//               <div className="chatbot-animation">
//                 <span role="img" aria-label="waving hand" className="waving-hand">👋</span>
//                 {/* Add a button or clickable text to trigger the chatbot */}
//                 <p 
//                   className="chat-message clickable-text" 
//                   onClick={handleChatClick} // Trigger chatbot response when clicked
//                 >
//                   Tap here to chat with us!
//                 </p>
//               </div>
//             </div>
//             <div ref={bottomRef}></div> {/* Reference to scroll to bottom */}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PopOutTabs;








// import React, { useState } from 'react';
// import './PopOutTabs.css';  // Ensure this file is in the same folder as your component

// const PopOutTabs = () => {
//   const [activeTab, setActiveTab] = useState(null); // Track which tab is open

//   const handleTabClick = (tabIndex) => {
//     setActiveTab((prevTab) => (prevTab === tabIndex ? null : tabIndex)); // Toggle tab visibility
//   };

//   return (
//     <div className="tabs-container">
//       {/* Tab 1 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(1)}
//         >
//           Info 1
//         </div>
//         {activeTab === 1 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             Government Audit and Internal Control Testing Services<br /></h3>

//             Understanding Government Audits<br /><br />

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning an absolutely high level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 2 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(2)}
//         >
//           Info 2
//         </div>
//         {activeTab === 2 && (
//           <div className="tab-content">
//             <h3>Understanding the Audit Process..<br />
//             Government Audit and Internal Control Testing<br /></h3>

//             <p>During the audit process, we gain a comprehensive 
//               understanding of internal controls and assess compliance 
//               with applicable regulations and standards. We also identify potential areas of risk, including fraud risk, 
//               and ensure that all relevant disclosures and amounts in the financial statements are properly supported through audit evidence. 
//               Our approach ensures transparency, accountability, and compliance with government standards.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 3 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(3)}
//         >
//           Info 3
//         </div>
//         {activeTab === 3 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             Government Audit and Internal Control Testing Services<br /></h3>

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning a high but not absolute level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 4 - Chatbot Invite */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(4)}
//         >
//           Chat with Us
//         </div>
//         {activeTab === 4 && (
//           <div className="tab-content">
//             <div className="chat-invite">
//               <h3>Let's Chat!</h3>
//               <p>
//                 To get the full scoop on how TJG CPAs can help you, why not chat with us? 
//                 Our chatbot is ready to answer your questions and provide you with more insights about our services.
//               </p>
//               <div className="chatbot-animation">
//                 <span role="img" aria-label="waving hand" className="waving-hand">👋</span>
//                 <p className="chat-message">Tap here to chat with us!</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PopOutTabs;











// import React, { useState } from 'react';
// import './PopOutTabs.css';  // Ensure this file is in the same folder as your component

// const PopOutTabs = () => {
//   const [activeTab, setActiveTab] = useState(null); // Track which tab is open

//   const handleTabClick = (tabIndex) => {
//     setActiveTab((prevTab) => (prevTab === tabIndex ? null : tabIndex)); // Toggle tab visibility
//   };

//   return (
//     <div className="tabs-container">
//       {/* Tab 1 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(1)}
//         >
//           Info 1
//         </div>
//         {activeTab === 1 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             <div><br></br></div>
//             Government Audit and Internal Control Testing Services<br /></h3>

//             Understanding Government Audits<br /><br />

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning an absolutely high level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 2 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(2)}
//         >
//           Info 2
//         </div>
//         {activeTab === 2 && (
//           <div className="tab-content">
//             <h3>Understanding the Audit Process..<br />
//             <div><br></br></div>
//             Government Audit and Internal Control Testing<br /></h3>

//             Understanding Government Audits<br /><br />

//             <p>During the audit process, we gain a comprehensive 
//               understanding of internal controls and assess compliance 
//               with applicable regulations and standards. We also identify potential areas of risk, including fraud risk, 
//               and ensure that all relevant disclosures and amounts in the financial statements are properly supported through audit evidence. 
//               Our approach ensures transparency, accountability, and compliance with government standards.
              
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Tab 3 */}
//       <div className="tab">
//         <div
//           className="tab-label"
//           onClick={() => handleTabClick(3)}
//         >
//           Info 3
//         </div>
//         {activeTab === 3 && (
//           <div className="tab-content">
//             <h3>WE PROVIDE DEPENDABLE<br />
//             Government Audit and Internal Control Testing Services<br /></h3>

//             Understanding Government Audits<br /><br />

//             <p>Our audit services offer the highest level of assurance, 
//               specifically designed to meet the needs of government agencies and programs. 
//               We provide an independent and objective evaluation to ensure the accuracy and reliability 
//               of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//               meaning a high but not absolute level of confidence that the financial statements are free from material misstatement.
//             </p>
//           </div>
//         )}
//       </div>

//       {/* Add more tabs as needed */}
//     </div>
//   );
// };

// export default PopOutTabs;











// import React from 'react';
// import './PopOutTabs.css';  // Make sure this file is in the same folder as your component

// const PopOutTabs = () => {
//   return (
//     <div className="tabs-container">
//       {/* Tab 1 */}
//       <div className="tab">
//         <div className="tab-label">Info 1</div>
//         <div className="tab-content">
//         <h3>WE PROVIDE DEPENDABLE<br />
//         Government Audit and Internal Control Testing Services<br /></h3>
    

//     Understanding Government Audits<br /><br />

//     <p>Our audit services offer the highest level of assurance, 
//       specifically designed to meet the needs of government agencies and programs. 
//       We provide an independent and objective evaluation to ensure the accuracy and reliability 
//       of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//       meaning a high but not absolute level of confidence that the financial statements are free from material misstatement.
//       </p>
//         </div>
//       </div>

//       {/* Tab 2 */}
//       <div className="tab">
//         <div className="tab-label">Info 2</div>
//         <div className="tab-content">
//         <h3>WE PROVIDE DEPENDABLE<br />
//         Government Audit and Internal Control Testing Services<br /></h3>
    

//     Understanding Government Audits<br /><br />

//     <p>Our audit services offer the highest level of assurance, 
//       specifically designed to meet the needs of government agencies and programs. 
//       We provide an independent and objective evaluation to ensure the accuracy and reliability 
//       of financial statements and internal controls. Our audit procedures aim to deliver “reasonable assurance,” 
//       meaning a high but not absolute level of confidence that the financial statements are free from material misstatement.
//       </p>
//         </div>
//       </div>

//       {/* Tab 3 */}
//       <div className="tab">
//         <div className="tab-label">Info 3</div>
//         <div className="tab-content">
//           <h3>Information 3</h3>
//           <p>This is some detailed information about the third tab.</p>
//         </div>
//       </div>

//       {/* Add more tabs as needed */}
//     </div>
//   );
// };

// export default PopOutTabs;
